import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY } from "@/data/site";

export const Footer = ({ onQuote }) => {
  return (
    <footer className="bg-mh-bg border-t border-mh-line">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr] gap-12">
          <div>
            <div className="flex flex-col leading-none mb-6">
              <span className="font-display font-black text-2xl tracking-tight text-white">MH ÉTANCHÉITÉ</span>
              <span className="text-[10px] tracking-[0.35em] uppercase text-mh-orange font-bold mt-1">Var • Alpes-Maritimes • PACA</span>
            </div>
            <p className="text-mh-slate max-w-sm leading-relaxed">
              Spécialiste de l'étanchéité de toiture terrasse, balcon, murs enterrés,
              isolation thermique, couvertines et dalles sur plots. Travaux garantis décennale.
            </p>
            <button onClick={onQuote} className="mt-8 bg-mh-orange hover:bg-mh-orangeHover text-white font-semibold px-6 py-3 transition-colors" data-testid="footer-quote-btn">
              Devis gratuit
            </button>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.25em] uppercase text-mh-orange font-bold mb-6">Contact</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/90"><MapPin size={16} className="text-mh-orange mt-0.5" /> {COMPANY.address}, {COMPANY.zip}</li>
              <li><a href={`tel:${COMPANY.phone}`} className="flex items-center gap-3 text-white/90 hover:text-mh-orange transition-colors"><Phone size={16} className="text-mh-orange" /> {COMPANY.phoneDisplay}</a></li>
              <li><a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 text-white/90 hover:text-mh-orange transition-colors"><Mail size={16} className="text-mh-orange" /> {COMPANY.email}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs tracking-[0.25em] uppercase text-mh-orange font-bold mb-6">Prestations</h4>
            <ul className="space-y-3 text-sm text-mh-slate">
              <li>Étanchéité toiture terrasse</li>
              <li>Étanchéité balcon</li>
              <li>Murs enterrés</li>
              <li>Isolation thermique</li>
              <li>Pose de couvertine</li>
              <li>Dalles sur plots</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-mh-line flex flex-col sm:flex-row justify-between gap-3 text-xs text-mh-muted">
          <span>© {new Date().getFullYear()} MH Étanchéité — Tous droits réservés.</span>
          <div className="flex items-center gap-4">
            <a href="/" className="hover:text-mh-orange transition-colors" data-testid="footer-light-link">Voir la version claire</a>
            <span>Garantie décennale • Devis gratuit</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
